(() => {
  const normalize = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-faq]').forEach((faq) => {
      if (faq.dataset.faqReady === 'true') return;
      faq.dataset.faqReady = 'true';

      const items = [...faq.querySelectorAll('[data-faq-item]')];
      const groups = [...faq.querySelectorAll('[data-faq-group]')];
      const empty = faq.querySelector('[data-faq-empty]');
      const input = faq.querySelector('[data-faq-search]');
      const navLinks = [...faq.querySelectorAll('[data-faq-nav-link]')];

      // Buscador: filtra por pregunta y respuesta, y oculta las categorías que se quedan vacías
      const texts = items.map((item) => normalize(item.textContent));

      const filter = () => {
        const words = normalize(input.value).split(/\s+/).filter(Boolean);
        let visible = 0;

        items.forEach((item, index) => {
          const match = words.every((word) => texts[index].includes(word));
          item.hidden = !match;
          if (match) visible += 1;
        });

        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
        });

        if (empty) empty.hidden = visible > 0;
      };

      if (input) {
        input.addEventListener('input', filter);
        input.form?.addEventListener('submit', (event) => event.preventDefault());
      }

      // Abre la pregunta si la URL trae su ancla
      const openFromHash = () => {
        const id = decodeURIComponent(window.location.hash.slice(1));
        if (!id) return;
        const target = document.getElementById(id);
        const details = target?.closest('[data-faq-item]') || target?.querySelector?.('[data-faq-item]');
        if (details && faq.contains(details)) details.open = true;
      };
      openFromHash();
      window.addEventListener('hashchange', openFromHash);

      // Categoría activa en el menú según el scroll
      if (navLinks.length && 'IntersectionObserver' in window) {
        const setActive = (id) => {
          navLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.faqNavLink === id));
        };

        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries.filter((entry) => entry.isIntersecting);
            if (visible.length) setActive(visible[0].target.id);
          },
          { rootMargin: '-20% 0px -65% 0px' }
        );

        groups.filter((group) => group.id).forEach((group) => observer.observe(group));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
